import React from 'react';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';
import { routes as LineupDataRoutes } from '../../LineupMatchup/containers/LineupDataContainer';
import { routes as MatchupDataRoutes } from '../../LineupMatchup/containers/MatchupDataContainer';
import { routes as MediaLinkRoutesRoutes } from '../../MediaLinks/MediaLinksDataContainer';
import { routes as PreviewInfoDataRoutes } from '../../PreviewInfo/containers/PreviewInfoDataContainer';
import { routes as TicketRoutes } from '../../TicketsButton/BuyTicketsButtonDataContainer';
import Preview from '../Preview';

const routes = [{
    path: '/:teams?/:year?/:month?/:day?/:gamepk/preview/:tab?/:detail?',
    exact: false,
    routes: [
        ...LineupDataRoutes,
        ...MatchupDataRoutes,
        ...MediaLinkRoutesRoutes,
        ...PreviewInfoDataRoutes,
        ...TicketRoutes
    ]
}];

const PreviewContainer = () => {
    return (
        <ErrorBoundaryWrapper componentName='Preview'>
            <Preview />
        </ErrorBoundaryWrapper>
    );
};

export default PreviewContainer;
export { routes };
